// extracted by mini-css-extract-plugin
module.exports = {"preview_pane":"FormPreviewPane_preview_pane__2Zbuy","narrowed":"FormPreviewPane_narrowed__1mkL5"};